<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <div class="settings-header">
            Business
            <div class="settings-header__btn">
              <el-button type="success" size="mini" @click="routerLink('settings-dashboard')">Settings Dashboard</el-button>
            </div>
          </div>

          <el-form :model="form" label-position="top" size="mini" status-icon ref="form">
            <el-row :gutter="20">
              <!-- <el-col :span="8" :offset="0">

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Country For Tax Reporting" prop="countryForTaxRepId">
                      <el-select v-model="form.countryForTaxRepId" placeholder="Country For Tax Reporting" clearable filterable style="width: 100%;">
                        <el-option v-for="item in countryForTaxRepList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Business Type" prop="businessTypeId">
                      <el-select v-model="form.businessTypeId" placeholder="Business Type" filterable style="width: 100%;">
                        <el-option v-for="item in businessTypeList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                          @click.native="form.businessTypeDesc = item.description">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20" v-if="form.businessTypeId">
                  <el-col :span="24" :offset="0">
                    <el-form-item prop="businessTypeDesc">
                      <el-input disabled label="" v-model="form.businessTypeDesc"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Business Formation" prop="businessFormationId">
                      <el-select v-model="form.businessFormationId" placeholder="Business Formation" clearable filterable style="width: 100%;">
                        <el-option v-for="item in businessFormationList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Registration Body" prop="registrationBody">
                      <el-input placeholder="Registration Body" v-model="form.registrationBody"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Registration Date" prop="registrationDate">
                      <el-date-picker
                        style="width: 100%;"
                        v-model="form.registrationDate"
                        :clearable='true'
                        format="d MMM yy"
                        value-format="MM-dd-yyyy"
                        type="date"
                        placeholder="Registration Date">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="DTI No." prop="DTINo">
                      <el-input placeholder="DTI No." v-model="form.DTINo"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Line Of Business" prop="lineOfBusinessId">
                      <el-select v-model="form.lineOfBusinessId" placeholder="Line Of Business" clearable filterable style="width: 100%;">
                        <el-option v-for="item in lineOfBusinessList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

              </el-col> -->
              <el-col :span="8" :offset="0">

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="" prop="isAddress">
                      <el-switch v-model="form.isAddress" active-text="Registered Office Address">
                      </el-switch>
                    </el-form-item>
                  </el-col>
                </el-row>

                <template v-if="form.isAddress">
                  <el-row :gutter="20">
                    <el-col :span="24" :offset="0">
                      <el-form-item label="Address Line 1" prop="address">
                        <el-input v-model="form.address" placeholder="Address Line 1"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24" :offset="0">
                      <el-form-item label="Address Line 2" prop="address2">
                        <el-input v-model="form.address2" placeholder="Address Line 2"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24" :offset="0">
                      <el-form-item label="Address Line 3" prop="address3">
                        <el-input v-model="form.address3" placeholder="Address Line 3"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24" :offset="0">
                      <el-form-item label="City" prop="cityId">
                        <el-select no-data-text="no data" v-model="form.cityId" @visible-change="loadCityList" :placeholder="$t('modal_city')" filterable style="width: 100%;">
                          <el-option
                            v-for="item in cityList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24" :offset="0">
                      <el-form-item label="State / Province / Country" prop="stateId">
                        <el-select no-data-text="no data" v-model="form.stateId" @visible-change="loadStateList" :placeholder="$t('modal_state')" filterable style="width: 100%;">
                          <el-option
                            v-for="item in stateList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            @click.native="setCity('main', item)">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24" :offset="0">
                      <el-form-item label="Post Code" prop="postCode">
                        <el-input v-model="form.postCode" placeholder="Post Code"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24" :offset="0">
                      <el-form-item label="Country" prop="countryId">
                        <el-select no-data-text="no data" v-model="form.countryId" @visible-change="loadCountryList" :placeholder="$t('modal_country')" filterable style="width: 100%;">
                          <el-option
                            v-for="item in countryList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            @click.native="setState('main', item)">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>

              </el-col>
            </el-row>

            <el-form-item>
              <el-button @click="save('form')" class="modal__btn" type="primary" plain size="small">{{$t('settings_companyAdditionalInfo_save')}}</el-button>
            </el-form-item>
          </el-form>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'settingBusiness',
  created() {
    this.directories()
    this.getStatutory()
  },
  data() {
    return {
      countryForTaxRepList: [],
      businessTypeList: [],
      businessFormationList: [],
      lineOfBusinessList: [],

      countryList: [],
      stateList: [],
      cityList: [],

      form: {
        // countryForTaxRepId: null,
        // businessTypeId: null,
        // businessTypeDesc: '',
        // businessFormationId: null,
        // registrationBody: null,
        // registrationDate: null,
        // DTINo: null,
        // lineOfBusinessId: null,

        isAddress: false,
        countryId: null,
        stateId: null,
        cityId: null,
        postCode: '',
        address: '',
        address2: '',
        address3: '',
      }
    }
  },
  watch: {
    'form.isAddress': function (val) {
      if (!val) {
        this.form.isAddress = false
        this.form.countryId = null
        this.form.stateId = null
        this.form.cityId = null
        this.form.postCode = ''
        this.form.address = ''
        this.form.address2 = ''
        this.form.address3 = ''
      }
    }
  },
  methods:{
    routerLink(page) {
      this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
    },
    directories() {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .post(`/api/v1/companies/directories?companyId=${this.$route.query.companyId}&operation=update`)
        .then(response => {
          this.countryForTaxRepList = response.data.countryList
          this.businessTypeList = response.data.businessType
          this.businessFormationList = response.data.businessFormation
          this.lineOfBusinessList = response.data.linesOfBusiness
        })
        .catch(error => {
          console.log('An error occurred:', error);
        });
    },
    getStatutory(){
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/company-business-info/item?companyId=${this.$route.query.companyId}`)
        .then(response => {
          // this.form.countryForTaxRepId = response.data.item.countryForTaxRepId
          // this.form.businessTypeId = response.data.item.businessTypeId
          // this.form.businessTypeDesc = response.data.item.businessTypeDesc
          // this.form.businessFormationId = response.data.item.businessFormationId
          // this.form.registrationBody = response.data.item.registrationBody
          // this.form.registrationDate = response.data.item.registrationDate
          // this.form.DTINo = response.data.item.DTINo
          // this.form.lineOfBusinessId = response.data.item.lineOfBusinessId

          this.form.isAddress = response.data.item.isAddress ? response.data.item.isAddress : false
          this.countryList.push(response.data.item.country)
          this.stateList.push(response.data.item.state)
          this.cityList.push(response.data.item.city)
          this.form.countryId = response.data.item.countryId
          this.form.stateId = response.data.item.stateId
          this.form.cityId = response.data.item.cityId
          this.form.postCode = response.data.item.postCode
          this.form.address = response.data.item.address
          this.form.address2 = response.data.item.address2
          this.form.address3 = response.data.item.address3
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
    loadList(type, id, arrType) {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/country/directories?type=${type}&id=${id}`)
        .then(response => {
          this[arrType] = response.data.list
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
    // Address
    loadCountryList(isVisiable) {
      if (isVisiable && this.countryList.length < 2) {
        this.loadList('country', null, 'countryList')
      }
    },
    loadStateList(isVisiable) {
      if (isVisiable && this.stateList.length < 2) {
        this.loadList('state', this.form.countryId, 'stateList')
      }
    },
    loadCityList(isVisiable) {
      if (isVisiable && this.cityList.length < 2) {
        this.loadList('city', this.form.stateId, 'cityList')
      }
    },
    setState(type, item) {
      if (type === 'main') {
        this.form.stateId = null;
        this.form.cityId = null;
        this.stateList = []
        this.cityList = []
      }
    },
    setCity(type, item) {
      if (type === 'main') {
        this.form.cityId = null
        this.cityList = []
      }
    },
    save(form){
      this.$refs[form].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/company-business-info/save?companyId=${this.$route.query.companyId}`, this.form)
            .then(response => {
              this.$message({
                type: 'success',
                message: 'Save'
              });
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        }
      });
    },
  }
}
</script>

<style lang="less" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper {
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      // max-width: 1500px;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}

/deep/.el-form-item__label {
  color: #000;
  font-weight: bold;
  padding: 0;
}
</style>
